
import "./ToolsChooser.css";
import { BsCalculator } from "react-icons/bs";
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

const ToolsChooser = () => {


const history = useHistory();

  return (
    <div className="ToolsChooserMainCOntainer">

      <h4>Narzędzia:</h4>

 <div className="ToolChooseContainer" onClick={() => history.push('/Kalkulator')}>
  <BsCalculator className="ChooserIcons"/>
  <p>Kalkulator parametrów spawania</p>
 </div>

 <div className="ToolChooseContainer" onClick={() => history.push('/KalkulatorDochodow')}>
  <BsCalculator className="ChooserIcons"/>
  <p>Kalkulator brutto netto</p>
 </div>

    </div>
  );
};

export default ToolsChooser;
